module.exports = __webpack_public_path__ + "static/media/0013.7672d4f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/0013.mp3
// module id = IV7v
// module chunks = 0